import { Badge } from "@/components/ui/badge";

import { useBadges } from "../data/queries";

/**
 * How much work is waiting, on every tab.
 *
 * This is what survives of Meteoric's `MachineChrome`. The rest of that header
 * was navigation — a second tab row and a system switcher — and the portal owns
 * navigation, so it is gone. The COUNTS are not navigation: "108 waiting in
 * review" is operational signal that exists nowhere else in the portal, because
 * the shell's tab labels are static and cannot carry a number.
 *
 * It renders nothing when every queue is empty. A row of zeroes is a row that
 * says "there is nothing here" in the most expensive possible way.
 */
export function StatusStrip() {
  const badges = useBadges();
  const counts = [
    { label: "in review", value: badges.data?.review ?? 0 },
    { label: "deferred to human", value: badges.data?.defer ?? 0 },
    { label: "to maintain", value: badges.data?.maintain ?? 0 },
  ].filter((count) => count.value > 0);

  if (counts.length === 0) return null;

  return (
    <p className="flex flex-wrap items-center gap-2" aria-label="Outstanding work">
      {counts.map((count) => (
        <Badge key={count.label} variant="outline" className="tabular-nums">
          {count.value.toLocaleString("en-US")} {count.label}
        </Badge>
      ))}
    </p>
  );
}
